import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Payload {
  username: string;
  code: string;
  newPassword: string;
}

const useResetPasswordQuery = () => {
  const { mutateAsync, isLoading } = useMutation((payload: Payload) =>
    api.post(API_URL.PASSWORDS_RESET, {
      username: payload.username,
      code: payload.code,
      password: payload.newPassword,
    })
  );

  return {
    resetPassword: mutateAsync,
    isLoading,
  };
};

export default useResetPasswordQuery;
